/**
 *
 * CustomTable
 *
 */

import React, { memo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.scss';

// antd component
import { Table, Empty } from 'antd';

// components
import Preloader from 'components/Preloader';

function CustomTable({
  // main
  dataSource,
  columns,
  loading,
  // optionals
  pagination,
  page,
  rowKey,
  hasSelection,
  // actions
  changeAction,
  onSelectChange,
  onPaginate,
  onRow,
  // default
  className,
  ...rest
}) {
  const childClassNames = classNames(`custom-table`, className);

  const [selectedRowKeys, SetSelectedRowKeys] = useState([]);

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const tableLocale = {
    triggerDesc: 'Cliquez pour trier par ordre decroissant',
    triggerAsc: 'Cliquez pour trier par ordre croissant',
    cancelSort: 'Cliquez pour annuler le tri',
    emptyText: (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={'Aucune donnée'}
      />
    ),
  };

  const onChangePaginate = useCallback((paginationData) => { 
    !!onPaginate && onPaginate(paginationData);
  }, [onPaginate]);

  const onChangeHandle = useCallback((pagination, filters, sorter, extra) => {
    const { action, ...rest } = extra;
    // action: paginate | sort | filter
    if (action == 'paginate') {
      onChangePaginate(pagination);
    }
    !!changeAction && changeAction(pagination, filters, sorter, extra);
  }, [changeAction]);

  return (
    dataSource && (
      <Table
        locale={tableLocale}
        className={childClassNames}
        dataSource={dataSource}
        columns={columns}
        onChange={onChangeHandle}
        rowSelection={hasSelection !== false ? rowSelection : null}
        pagination={pagination}
        page={page}
        rowKey={rowKey}
        onRow={onRow}
        loading={{
          spinning: loading,
          indicator: <Preloader />,
        }}
        {...rest}
      />
    )
  );
}


CustomTable.defaultProps = {
  page: null,
  rowKey: record => record._id,
  hasSelection: false,
  pagination: false,
  loading: false,
};
CustomTable.propTypes = {
  hasSelection: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  changeAction: PropTypes.func,
  onSelectChange: PropTypes.func,
};

export default memo(CustomTable);